// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

export const APPLY_EXCEPTION_REVIEW_MUTATION =
  "mondoo.policy.ExtendedHub.ApplyExceptionReviewMutation";
